import { render, staticRenderFns } from "./LostItems.vue?vue&type=template&id=5a53f5c4&scoped=true&"
import script from "./LostItems.vue?vue&type=script&lang=js&"
export * from "./LostItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53f5c4",
  null
  
)

export default component.exports